import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App.tsx'
import ErrorBoundary from './components/ErrorBoundary'
import { initLangSmith } from './lib/langsmith'
import { initPostHog } from './lib/posthog'
import { initSentry } from './lib/sentry'
import './index.css'
import './lib/supabase'

// Initialize Sentry and LangSmith
initSentry()
initPostHog()
initLangSmith().catch(() => {})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>,
)

